export default "__VITE_PUBLIC_ASSET__0ca0aa8c__"